module.exports = __webpack_public_path__ + "img/visa-card-small.7c52bb0c.png";